// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client'; // Make sure you're importing from 'react-dom/client'
import './index.css'; // Make sure the file exists, or remove this import
import App from './App';

// Create a root element and render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
